import { render, staticRenderFns } from "./reg-sync-modal.vue?vue&type=template&id=a7883e44&"
import script from "./reg-sync-modal.vue?vue&type=script&lang=js&"
export * from "./reg-sync-modal.vue?vue&type=script&lang=js&"
import style0 from "./reg-sync-modal.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/opt/planorama/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('a7883e44')) {
      api.createRecord('a7883e44', component.options)
    } else {
      api.reload('a7883e44', component.options)
    }
    module.hot.accept("./reg-sync-modal.vue?vue&type=template&id=a7883e44&", function () {
      api.rerender('a7883e44', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "app/javascript/integrations/reg-sync-modal.vue"
export default component.exports